import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorizatedAdminGuard } from './authorizated-admin.guard';
import { AuthorizatedAgentGuard } from './authorizated-agent.guard';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
  ],
  providers:[
      AuthorizatedAdminGuard,
      AuthorizatedAgentGuard
  ]
})
export class GuardModule { }


// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend/src/app/guard/guard.module.ts